$(document).ready(function () {
	// calculate brightness for background colors

	jQuery.fn.brightness = function () {
		// eslint-disable-line consistent-return
		var rgba = void 0,
		    y = void 0;
		var bgColor = this.css('background-color');
		if (bgColor != null && bgColor.length) {
			rgba = bgColor.match(/^rgb(?:a)?\(([0-9]{1,3}),\s([0-9]{1,3}),\s([0-9]{1,3})(?:,\s)?([0-9]{1,3})?\)$/);
			if (rgba != null) {
				if (rgba[4] === '0') {
					if (this.parent().length) return this.parent().brightness();
				} else {
					y = 2.99 * rgba[1] + 5.87 * rgba[2] + 1.14 * rgba[3];
					if (y >= 1800) {
						return 'light';
					} else {
						return 'dark';
					}
				}
			}
		} else if (this.parent().length) return this.parent().brightness();
	};

	// if background color is dark change footer class

	if ($('body').brightness() === 'dark') {
		$(' footer, .unsubscribe').addClass('has-dark-bg');
	}

	// if foreground color is dark change container class

	if ($('main > .container').brightness() === 'dark') {
		$('header, main').addClass('has-dark-bg');
	}
});